import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

export function useDashboardAppointmentList({ endpoint, startDate, endDate }) {
  const navigate = useNavigate();

  const [appointments, setAppointments] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAppointments = useCallback(() => {
    if (!startDate?.isValid() || !endDate?.isValid()) {
      return;
    }

    const params = {
      initialDate: startDate.format('YYYY-MM-DD'),
      finalDate: endDate.format('YYYY-MM-DD'),
    };

    setLoading(true);
    quarkusApi
      .get(endpoint, {
        headers: { Authorization: sessionStorage.getItem('token') },
        params,
      })
      .then((returnFromApi) => setAppointments(returnFromApi.data))
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data ?? 'Erro ao carregar consultas.');
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [endpoint, startDate, endDate, navigate]);

  useEffect(() => {
    fetchAppointments();
  }, [fetchAppointments]);

  return { appointments, isLoading, error, refetch: fetchAppointments };
}
